// removed by extract-text-webpack-plugin
module.exports = {"container":"_2NZd5","name":"_2F9CD","large":"_3DkaF"};


//////////////////
// WEBPACK FOOTER
// ./app/components/avatar/avatar.scss
// module id = 836
// module chunks = 3 4 5 6 7